import { render, staticRenderFns } from "./AddMtcLabModal.vue?vue&type=template&id=1fc084c5&scoped=true&"
import script from "./AddMtcLabModal.vue?vue&type=script&lang=js&"
export * from "./AddMtcLabModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMtcLabModal.vue?vue&type=style&index=0&id=1fc084c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc084c5",
  null
  
)

export default component.exports